'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Benutzer, Rolle } from '@/lib/api/auth-types';
import { setAuthToken } from '@/lib/api/client';

interface AuthState {
  token: string | null;
  benutzer: Benutzer | null;
  istAngemeldet: boolean;
  login: (token: string, benutzer: Benutzer) => void;
  logout: () => void;
  hatRolle: (...rollen: Rolle[]) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      benutzer: null,
      istAngemeldet: false,

      login: (token: string, benutzer: Benutzer) => {
        setAuthToken(token);
        set({ token, benutzer, istAngemeldet: true });
      },

      logout: () => {
        setAuthToken(null);
        set({ token: null, benutzer: null, istAngemeldet: false });
      },

      hatRolle: (...rollen: Rolle[]) => {
        const { benutzer } = get();
        if (!benutzer) return false;
        if (benutzer.rolle === 'admin') return true;
        return rollen.includes(benutzer.rolle);
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        token: state.token,
        benutzer: state.benutzer,
        istAngemeldet: state.istAngemeldet,
      }),
    },
  ),
);
